
import HomePage from '../pages/home.vue';
import AboutPage from '../pages/about.vue';
import FormPage from '../pages/form.vue';
import CatalogPage from '../pages/catalog.vue';
import ProductPage from '../pages/product.vue';
import SettingsPage from '../pages/settings.vue';

import DynamicRoutePage from '../pages/dynamic-route.vue';
import RequestAndLoad from '../pages/request-and-load.vue';
import NotFoundPage from '../pages/404.vue';

var pathName=window.location.pathname;
console.log("pathname:"+pathName);
function urlToPath(){
  if(pathName=="/about/"){return AboutPage; }else{
    return HomePage;
  }
}
var gotoPage=urlToPath();

var routes = [
  {
    path: '/',
 
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      app.request.post('https://foodfile.co.kr/app/store_test.php','ServiceValue={"member_id":"10156098058910567"}',function (data) {
        //console.log(data);
        console.log("foodfile data:");
        var menus = JSON.parse(data);
           // Hide Preloader
           app.preloader.hide();

           // Resolve route to load page
           resolve(
             {
               component: HomePage,
             },
             {
               context: {
                menus: menus,
                
               }
             }
           );
      });

    },
 
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/catalog/',
    component: CatalogPage,
  },
  {
    path: '/product/:menuid/:itemid',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();
      var itemid = routeTo.params.itemid;
      var menuid = routeTo.params.menuid;
      // Simulate Ajax Request
      app.request.post('https://foodfile.co.kr/app/menusel_test.php','ServiceValue={"itemid":"'+itemid+'","menuid":"'+menuid+'"}',function (data) {
        //console.log(data);
        console.log("foodfile data:");
        var menus = JSON.parse(data);
           // Hide Preloader
           app.preloader.hide();

           // Resolve route to load page
           resolve(
             {
              component: ProductPage,
             },
             {
               context: {
                selected_menu: menus,
                
               }
             }
           );
      });

    },



  },
  {
    path: '/settings/',
    component: SettingsPage,
  },

  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;

